import { CardSvg } from '@/play/cardSvg'

/**
 * Home card art for Reading shelf: a walnut shelf with three letter blocks on it (O M A), the middle
 * one's letter lit as it is read, sound coming from a mouth; one block still on the floor. No text:
 * the letters are strokes.
 */
export function ReadingShelfCardArt() {
  return (
    <CardSvg bg="#f3f6f8">
      <path d="M10 190 L 50 128 H 300 L 312 190 Z" fill="#dfe6ea" />
      <path d="M44 94 H 300 L 296 112 H 40 Z" fill="#a8774f" />
      <path d="M40 112 H 296 V 132 H 40 Z" fill="#8f6040" />
      <Block x={78} y={60} ink="#2a9d4b" letter="M24 8 C 14 8, 14 30, 24 30 C 34 30, 34 8, 24 8 Z" />
      <Block x={128} y={60} ink="#ffb703" letter="M15 30 V 8 L 24 20 L 33 8 V 30" />
      <Block x={178} y={60} ink="#2f7dd1" letter="M15 30 L 24 8 L 33 30 M 18 22 H 30" />
      <Block x={150} y={146} ink="#e8559a" letter="M31 10 C 24 5, 15 9, 18 16 C 21 22, 32 20, 30 27 C 28 33, 18 32, 15 28" />
      <path d="M252 46 Q 262 40, 270 46 Q 262 56, 252 46 Z" fill="#e63946" stroke="#1d2b36" strokeWidth="2" />
      <path d="M276 40 Q 280 46, 276 52 M 282 35 Q 289 46, 282 57" fill="none" stroke="#1d2b36" strokeWidth="2.2" strokeLinecap="round" />
    </CardSvg>
  )
}

/** One block in a simple oblique view: top with the raised letter, front face. */
function Block({ x, y, ink, letter }: { x: number; y: number; ink: string; letter: string }) {
  return (
    <g transform={`translate(${x} ${y})`}>
      <path d="M0 10 L 10 0 H 48 L 38 10 Z" fill="#f1d3a6" stroke="#d2a86e" strokeWidth="1.5" />
      <rect x="0" y="10" width="38" height="26" fill="#e8c48e" stroke="#d2a86e" strokeWidth="1.5" />
      <path d="M38 10 L 48 0 V 26 L 38 36 Z" fill="#d2a86e" />
      <g transform="translate(-4 13) scale(0.9 0.75)">
        <path d={letter} fill="none" stroke={ink} strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </g>
  )
}
